// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox-module--checkbox--lKwRa","checkbox__caption":"checkbox-module--checkbox__caption--3zGCD"};